export default __webpack_public_path__ + "static/media/DOG.150cbd26.wav";